module.exports = __webpack_public_path__ + "img/icon2.d1c65c5b.png";